import { Component, EventEmitter, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { AnessaTranslationService } from '../translation/anessa-translation.service';
import { UserpilotReloader } from '../userpilot-reloader.component';
import { ConfirmationDialogData } from '../../models/helper/confirmation-dialog.model';

@Component({
  selector: 'app-confirmation-dialog-component',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent extends UserpilotReloader implements OnInit, OnDestroy {
  onDestroyNotifier = new EventEmitter();
  /** trigger for translation pipe */
  trigger?: string;

  /**
   * The message that will be shown in the prompt, this can be set manually in the constructor with
   * the data injected.
   */
  confirmMessage = '';
  /**
   * The text that is shown in the confirm button.
   */
  confirmText = 'PROJECT.COMMON.CONFIRM';
  /**
   * The text that is shown in the cancel button.
   */
  rejectText = 'PROJECT.COMMON.CANCEL';

  /**
   * Text that is shown as additional info, underneath the 'confirm' message
   */
  additionalInfo = '';

  constructor(private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
              public translationService: AnessaTranslationService,
              @Inject(MAT_DIALOG_DATA) data: ConfirmationDialogData
  ) {
    super();
    this.confirmMessage = this.translationService.get('PROJECT.COMMON.ARE_YOU_SURE');
    // updates the message shown in the popup.
    if (data && data.message) {
      this.confirmMessage = data.message;
      if (data.confirmText) {
        this.confirmText = data.confirmText;
      }
      if (data.rejectText) {
        this.rejectText = data.rejectText;
      }
    }
    if (data?.additionalInfo) {
      this.additionalInfo = data.additionalInfo;
    }
  }

  ngOnInit(): void {
    this.translationService.languageChangeNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(() => {
        this.trigger = this.translationService.getCurrentLang();
      });
  }

  ngOnDestroy() {
    this.onDestroyNotifier.emit();
    this.onDestroyNotifier.unsubscribe();
  }

  /**
   * Closes the dialog with true being returned.
   */
  confirmClick() {
    this.dialogRef.close(true);
  }

  /**
   * Closes the dialog with false being returned.
   */
  rejectClick() {
    this.dialogRef.close(false);
  }
}
